<script lang="ts">
	import { makeComponentClassList } from "../utils";
	import { DefaultLoading } from "../SVG";
	export let disabled = false;
	export let fitmode = false;
	export let defaultClassname = "";
	export let noneBordercolor = false;
	export let isLoading = false;
	export let nonePadding = false;
	export let center = false;
	let hovering = false;
	$: classVariables = makeComponentClassList($$props);

</script>

<button
	type="button"
	on:mouseenter={() => {
		hovering = true;
	}}
	on:mouseleave={() => {
		hovering = false;
	}}
	on:click
	class:nonePadding
	class:center
	class:noneBorder={noneBordercolor}
	class:loading={isLoading}
	class:fitmode
	disabled={disabled}
	class={defaultClassname + classVariables}>
	{#if isLoading}
		<DefaultLoading inlineMode />
	{:else}
		<slot hovering={hovering} />
	{/if}
</button>

<style lang="scss">
	@import "../variables.scss";
	button {
		width: 100%;
		height: 40px;
		border-radius: 5px;
		border: solid 1px #b4b7bb;
		transition: all 0.15s;
		box-sizing: border-box;
		background-color: transparent;
		&.nonePadding {
			padding: 0;
		}

		&.center {
			display: flex;
			align-items: center;
			justify-content: center;
		}

		&.loading {
			display: flex;
			justify-content: center;
			align-items: center;
		}

		&.noneBorder {
			border: none !important;

			&:disabled {
				background-color: transparent;
			}
		}

		&:not(:disabled):hover {
			cursor: pointer;
		}

		&:disabled {
			background-color: var(--default-disabled-btn-1);
			border: none;
		}

		&.fitmode {
			height: 100%;
		}

		&:not(:disabled):active {
			border-color: var(--default-active-btn-1);
			box-shadow: 0 0 0 1px rgba(42, 44, 46, 0.15) inset,
				0 0 0 0 rgba(42, 44, 46, 0.15);
		}
	}
	@include DesktopSize {
		button {
			&:not(:disabled):hover {
				border-color: var(--default-hover-btn-1);
				box-shadow: 0 0 0 1px transparent inset, 0 0 0 0 rgba(34, 36, 38, 0.15);
			}
		}
	}

</style>
